export const environment = {
  production: true,
  buildId: '3889968209023771',
  configFile: 'config.json',
};
